import ParkingLocationsPageView from "./ParkingLocationsPageView";

function ParkingLocationsPage() {
  return <ParkingLocationsPageView />;
}

export default ParkingLocationsPage;
